import DisplayTypeIcon from 'components/DisplayTypeIcon';
import Label from './Label';

const ServerDetailsDisplayType = ({ displayType }: { displayType: string }) => (
	<>
		<DisplayTypeIcon
			displayType={displayType || ''}
			sx={({ vars, size }) => ({
				color: vars.palette.uc.icon.weak,
				height: size.xS,
				width: size.xS,
				flexShrink: 0,
			})}
		/>
		<Label>{displayType}</Label>
	</>
);

export default ServerDetailsDisplayType;
